export const enum LocalStorageKeys {
  PreviouslySeenHotels = 'previouslySeenHotels',
}
